export default __webpack_public_path__ + "static/media/website.dcdaa9ee.png";